/**
 * Une durée s'écrit comme on la dit : « 8 h 30 », « 8h30 », « 8:30 », « 8,5 »,
 * « 45 min ». Un champ numérique en décimales (« 8.5 ») obligeait le salarié à
 * convertir ses minutes lui-même, et un « 8.30 » lu comme 8 h 18 est la faute
 * que ce format évite.
 */

const HEURES_DECIMALES = /^(\d+(?:\.\d+)?)$/;
const HEURES_MINUTES = /^(\d{1,2})\s*(?:h|:)\s*(?:(\d{1,2})\s*(?:min)?)?$/;
const MINUTES = /^(\d{1,4})\s*min$/;
const MAX_HEURES = 24;

/** Les heures (décimales) d'une saisie, ou `null` si elle n'est pas une durée de 0 à 24 h. */
export const lireDuree = (texte) => {
  const saisie = String(texte ?? '').trim().toLowerCase().replace(',', '.');
  if (!saisie) return null;

  let heures = null;
  const decimales = HEURES_DECIMALES.exec(saisie);
  const heuresMinutes = HEURES_MINUTES.exec(saisie);
  const minutes = MINUTES.exec(saisie);
  if (decimales) {
    heures = Number(decimales[1]);
  } else if (heuresMinutes) {
    const reste = heuresMinutes[2] === undefined ? 0 : Number(heuresMinutes[2]);
    if (reste > 59) return null;
    heures = Number(heuresMinutes[1]) + reste / 60;
  } else if (minutes) {
    heures = Number(minutes[1]) / 60;
  }

  if (heures === null || heures > MAX_HEURES) return null;
  return Math.round(heures * 10000) / 10000;
};

/** L'écriture d'une durée que `lireDuree` relit sans perte : « 8 h », « 8 h 05 ». */
export const dureeEnSaisie = (valeur) => {
  const minutes = Math.round((valeur || 0) * 60);
  const heures = Math.floor(minutes / 60);
  const reste = minutes % 60;
  return reste ? `${heures} h ${String(reste).padStart(2, '0')}` : `${heures} h`;
};
